module.exports = __webpack_public_path__ + "assets/media/lunch.fadaff16.mp3";